"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineClampWrapper = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var mixins_1 = require("../../../../../themes/mixins");
var LineClampWrapperStyled = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  ", " {\n    ", "\n  }\n"], ["\n  ", "\n\n  ", " {\n    ", "\n  }\n"])), function (_a) {
    var noOfLines_D = _a.noOfLines_D, noOfLines_M = _a.noOfLines_M;
    return (noOfLines_M && (0, mixins_1.clampText)(noOfLines_M)) || (noOfLines_D && (0, mixins_1.clampText)(noOfLines_D));
}, (0, mixins_1.mediaQuery)("sm"), function (_a) {
    var noOfLines_D = _a.noOfLines_D, noOfLines_M = _a.noOfLines_M;
    return (noOfLines_D && (0, mixins_1.clampText)(noOfLines_D)) || (noOfLines_M && (0, mixins_1.clampText)(noOfLines_M));
});
var LineClampWrapper = function (_a) {
    var title = _a.title, children = _a.children, noOfLines_D = _a.noOfLines_D, noOfLines_M = _a.noOfLines_M;
    return (react_1.default.createElement(LineClampWrapperStyled, { title: title, noOfLines_D: noOfLines_D, noOfLines_M: noOfLines_M }, children));
};
exports.LineClampWrapper = LineClampWrapper;
var templateObject_1;
